















































































import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import ProConfig from '@/config/config'
import LabelValueUtils from '@/utils/LabelValueUtils'
import JavaHttp from '@/common/network/JavaHttp'
import FuncUtils from '@/common/utils/FuncUtils'
import ValidateUtils from '@/common/utils/ValidateUtils'

@Component({
  name: 'FormForgetPassword',
  components: {}
})
export default class FormForgetPassword extends Vue {
  @Prop({ required: true }) public srcData!: any
  @Prop({ default: false }) public uiStatus!: number
  public formRules = {
    phone: [
      { required: true, message: '手机号码必填' },
      { validator: ValidateUtils.validateMobile }
    ],
    newPassword: [{ required: true, message: '新密码必填' }],
    onceMore: [
      { required: true, message: '确认密码必填' },
      {
        validator: (rule: any, value: any, callback: Function) => {
          if (!this.formData.newPassword) {
            callback(new Error('请填写新密码'))
            return
          }
          if (this.formData.newPassword == this.formData.onceMore) {
            callback()
          } else {
            callback(new Error('密码不一致'))
          }
        }
      }
    ],
    code: [{ required: true, message: '验证码必填' }]
  }

  public formData = {
    phone: '',
    newPassword: '',
    onceMore: '',
    code: ''
  }
  public getCodeStatus = false
  public btnContent = '获取验证码'
  public btnLoading = false
  public uiLock = false

  submitForm() {
    const form: any = this.$refs.formData
    form.validate((valid: any) => {
      if (valid) {
        this.submitData()
      } else {
        return false
      }
    })
  }

  resetForm() {
    const form: any = this.$refs.formData
    form.resetFields()
  }

  closeForm() {
    this.resetForm()
    this.$emit('cancelDlg')
  }

  getCode() {
    const form: any = this.$refs.formData
    form.validateField('phone', (msg: any) => {
      if (msg) {
        return
      }
      this.getCodeStatus = true
      JavaHttp.getData('/public/sendMsmCode/' + this.formData.phone)
        .then((res: any) => {
          if (res.code == 200) {
            FuncUtils.hitMessageSuccess(res.message)
            this.btnContent = '等待(60秒)'
            let waitSecond = 60
            const timeId = setInterval(() => {
              waitSecond--
              if (waitSecond == 0) {
                this.btnContent = '获取验证码'
                this.getCodeStatus = false
                clearInterval(timeId)
                return
              }
              this.btnContent = '等待(' + waitSecond + '秒)'
            }, 1000)
          } else {
            this.btnContent = '获取验证码'
            this.getCodeStatus = false
            FuncUtils.hitMessageError(res.message)
          }
        })
        .catch((error) => {
          this.getCodeStatus = false
        })
    })
  }
  submitData() {
    this.btnLoading = true
    const params = {
      phone: this.formData.phone,
      newPassword: this.formData.newPassword,
      code: this.formData.code
    }
    JavaHttp.postDataCallback(
      '/public/updateUserPassword',
      params,
      (result: boolean, data: any) => {
        this.btnLoading = false
        if (result === true) {
          if (data.code == 200) {
            this.$emit('submitDlg', true)
            FuncUtils.hitMessageSuccess(data.message)
          } else {
            FuncUtils.hitMessageError(data.message)
          }
        }
      }
    )
  }
}
